import { render, staticRenderFns } from "./tipTemplate.vue?vue&type=template&id=20ea3910&scoped=true"
import script from "./tipTemplate.vue?vue&type=script&lang=js"
export * from "./tipTemplate.vue?vue&type=script&lang=js"
import style0 from "./tipTemplate.vue?vue&type=style&index=0&id=20ea3910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea3910",
  null
  
)

export default component.exports